var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var MetricsEventType;
(function (MetricsEventType) {
    MetricsEventType["AccordionPanelExpand"] = "click:auth0-docs:expand-accordion-panel";
    MetricsEventType["AccordionPanelCollapse"] = "click:auth0-docs:close-accordion-panel";
    MetricsEventType["AccordionSearchExpandAll"] = "find:auth0-docs:expand-all-accordion-panels-on-search";
    MetricsEventType["AccordionPanelTimeOpen"] = "change:auth0-docs:accordion-panel-time-open";
    MetricsEventType["TabPanelClick"] = "click:auth0-docs:tab-panel-click";
    MetricsEventType["TabPanelTimeOpen"] = "change:auth0-docs:tab-panel-time-open";
    MetricsEventType["FeedbackSubmitComment"] = "submit:auth0-docs:feedback-comment";
    MetricsEventType["FeedbackBooleanClick"] = "click:auth0-docs:feedback-boolean";
    MetricsEventType["DefinitionTooltipOpen"] = "hover:auth0-docs:open-definition-tooltip";
    MetricsEventType["DefinitionTooltipClick"] = "click:auth0-docs:follow-definition-tooltip-link";
})(MetricsEventType || (MetricsEventType = {}));
var MetricsLoader = /** @class */ (function () {
    function MetricsLoader() {
        this.ready = false;
        this.buffer = [];
    }
    MetricsLoader.prototype.init = function () {
        if (typeof window !== 'undefined' && typeof window.Auth0Metrics === 'function') {
            window.metricsLib = this;
            var _a = window.env, SEGMENT_KEY = _a.SEGMENT_KEY, DWH_ENDPOINT = _a.DWH_ENDPOINT;
            if (!DWH_ENDPOINT || !SEGMENT_KEY) {
                console.warn('DWH_ENDPOINT and SEGMENT_KEY must be defined. All metrics events will be ignored.');
            }
            else {
                this.setup({
                    segmentKey: SEGMENT_KEY,
                    dwhEndpoint: DWH_ENDPOINT,
                });
            }
        }
    };
    MetricsLoader.prototype.setup = function (_a) {
        var _this = this;
        var segmentKey = _a.segmentKey, dwhEndpoint = _a.dwhEndpoint;
        window.metricsLib = new window.Auth0Metrics(segmentKey, dwhEndpoint, 'docs');
        window.metricsLib.ready(function () {
            _this.ready = true;
            _this.execBuffer();
        });
    };
    MetricsLoader.prototype.execBuffer = function () {
        this.buffer.forEach(function (bufferedCall) { return bufferedCall(); });
    };
    MetricsLoader.prototype.track = function () {
        var _a;
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this.ready) {
            this.buffer.push(function () { return _this.track.apply(_this, __spreadArray([], __read(args), false)); });
            return;
        }
        (_a = window.metricsLib).track.apply(_a, __spreadArray([], __read(args), false));
    };
    MetricsLoader.prototype.page = function () {
        var _a;
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this.ready) {
            this.buffer.push(function () { return _this.page.apply(_this, __spreadArray([], __read(args), false)); });
            return;
        }
        (_a = window.metricsLib).page.apply(_a, __spreadArray([], __read(args), false));
    };
    return MetricsLoader;
}());
var metrics = new MetricsLoader();
// Register the first page view.
metrics.page();
export default metrics;
